var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1965_2885)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 21.5001V24.0001H18V21.5001C18 20.1221 16.878 19.0001 15.5 19.0001H8.50001C7.12201 19.0001 6.00001 20.1221 6.00001 21.5001V24.0001H4.00001V21.5001C4.00001 19.0191 6.01901 17.0001 8.50001 17.0001H15.5C17.981 17.0001 20 19.0191 20 21.5001ZM22 4.5001V12.0001H20V5.4711L18 6.4711V9.0001C18 12.3091 15.309 15.0001 12 15.0001C8.69101 15.0001 6.00001 12.3091 6.00001 9.0001V6.4711L2.05701 4.5001L10.276 0.392102C11.323 -0.128898 12.675 -0.129898 13.722 0.392102L22 4.5001ZM6.53001 4.5001L11.171 6.8201C11.651 7.0601 12.348 7.0601 12.829 6.8201L17.47 4.5001L12.829 2.1801C12.35 1.9411 11.65 1.9401 11.17 2.1801L6.53001 4.5001ZM16 7.4711L13.724 8.6091C13.201 8.8711 12.6 9.0021 12 9.0021C11.4 9.0021 10.8 8.8711 10.276 8.6091L8.00001 7.4711V9.0001C8.00001 11.2061 9.79401 13.0001 12 13.0001C14.206 13.0001 16 11.2061 16 9.0001V7.4711Z",
    fill: "#2E2E2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1965_2885"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudent);
export default __webpack_public_path__ + "static/media/student.57c35cd63c8a1bbc76492822f8b0b391.svg";
export { ForwardRef as ReactComponent };